export const TOP_LAYER_COLOR = "#FF0000"
export const BOTTOM_LAYER_COLOR = "#0000FF"
export const DEFAULT_TRACE_THICKNESS = 0.15
export const HIGHLIGHT_COLOR = "rgba(245, 158, 11, 0.16)"
export const ACCEPT_COLOR = "rgba(16, 185, 129, 0.14)"
export const REJECT_COLOR = "rgba(220, 38, 38, 0.14)"
export const CANDIDATE_STROKE = "#000000"
export const EPSILON = 1e-6
export const TRACE_CLEARANCE_REGRESSION_MAX = 0.1
export const MAX_REPAIR_PASSES = 1

export const BOUNDARY_SIDES = ["top", "bottom", "left", "right"] as const
